// Commons functions used anywhere

export const formatCurrency = (pValue, pSize, pCurrency) => {
	
	//pValue = isNaN(pValue) ? 0 : pValue
	const fractionDigits 	= pSize === 'SMALL' ? 2 : 0 
	let region				= 'pt-BR'
	let currency			= 'BRL'

	switch (pCurrency) {
		case 'USD' : [region,currency] = ['en-US','USD']; break;
		case 'EUR' : [region,currency] = ['en-US','EUR']; break;
		case 'JPY' : [region,currency] = ['en-US','JPY']; break;
		case 'CNY' : [region,currency] = ['en-US','CNY']; break;
		case 'MXN' : [region,currency] = ['en-US','MXN']; break;
		case 'THB' : [region,currency] = ['en-US','THB']; break;
		case 'SEK' : [region,currency] = ['en-US','SEK']; break;
		case 'GBP' : [region,currency] = ['en-US','GBP']; break;
		case 'CAD' : [region,currency] = ['en-US','CAD']; break;
		case 'HKD' : [region,currency] = ['en-US','HKD']; break;
		case 'IDR' : [region,currency] = ['en-US','IDR']; break;
		case 'TWD' : [region,currency] = ['en-US','TWD']; break;
		case 'DKK' : [region,currency] = ['en-US','DKK']; break;
		case 'AUD' : [region,currency] = ['en-US','AUD']; break;
		case 'SGD' : [region,currency] = ['en-US','SGD']; break;
		case 'NOK' : [region,currency] = ['en-US','NOK']; break;
		case 'COP' : [region,currency] = ['en-US','COP']; break;
		case 'CHF' : [region,currency] = ['en-US','CHF']; break;
		case 'INR' : [region,currency] = ['en-US','INR']; break;
		case 'KRW' : [region,currency] = ['en-US','KRW']; break;
		case 'MYR' : [region,currency] = ['en-US','MYR']; break;
		case 'VND' : [region,currency] = ['en-US','VND']; break;	
		case 'ZAR' : [region,currency] = ['en-US','ZAR']; break;	
	}	
	
	return new Intl.NumberFormat(region, {
		style 					: "currency",
		currency 				: currency,
		maximumFractionDigits	: fractionDigits, 
		minimumFractionDigits	: fractionDigits, 
	}).format(pValue)

}

export const convertDbNumberToHtml = (pValue) => {
	return pValue.replace(/\./, ',')
}


